export const roundUpByStep = (
    numberToRound: number,
    step: number,
    allowedSteps: number[],
    maximum?: number | undefined,
) => {
    let roundedNumber = 0;
    const maxFloatDigits = 6;

    if (allowedSteps.includes(numberToRound)) {
        roundedNumber = numberToRound;
    } else {
        roundedNumber = Math.round(numberToRound / step) * step;
        roundedNumber = Math.round(roundedNumber * 1000000) / 1000000;
    }

    if (maximum && roundedNumber > maximum) {
        return Math.round(maximum * 1000000) / 1000000;
    }

    return roundedNumber;
};
